import { FieldConfigSchema, type FieldType, TYPE_WIDENINGS } from '@servicetim/shared';

export const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  text: 'Text',
  long_text: 'Long text',
  number: 'Number',
  date: 'Date',
  datetime: 'Date & time',
  boolean: 'Checkbox',
  single_select: 'Single select',
  multi_select: 'Multi select',
  user: 'User',
  multi_user: 'Multiple users',
  tags: 'Tags',
  url: 'URL',
  email: 'Email',
  phone: 'Phone',
  ticket_lookup: 'Ticket lookup',
};

export const isSelectType = (type: FieldType): boolean =>
  type === 'single_select' || type === 'multi_select';

/** Whitelisted widening targets (ADR-0013 §2); empty for types that cannot change. */
export const wideningTargets = (type: FieldType): readonly FieldType[] => TYPE_WIDENINGS[type];

/** The defaulted config for a type, without the `type` discriminator (what the API stores). */
export function defaultConfigFor(type: FieldType): Record<string, unknown> {
  const parsed = FieldConfigSchema.parse({ type }) as Record<string, unknown>;
  return Object.fromEntries(Object.entries(parsed).filter(([key]) => key !== 'type'));
}

/** Drops the `type` key a stored `FieldConfig` carries so it can be PATCHed back unchanged. */
export const stripConfigType = (config: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(Object.entries(config).filter(([key]) => key !== 'type'));
